import React from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import {
  SiteShell, PageHead, H1, P, INK, SUB, LINE, CARD, BG2,
} from '../site/shell';

const sec = { padding:'clamp(40px,6vw,72px) clamp(20px,5vw,48px)' };

/* ══════════════════════════════════════════════════════════════════
   BLOG — the only part that brings in new visitors. One post a month.
   Fill `body` (array of paragraphs/headings) to publish; without `body`
   it shows the "coming soon" state. Each post points to a product.
   TODO(pmf): write the articles and set the real publish date.
   ══════════════════════════════════════════════════════════════════ */
export const POSTS = [
  { slug:'mirror-self-hosted-without-photon', title:'Mirror self-hosted, without Photon',
    excerpt:'How to stand up multiplayer in Unity over Mirror, hosted by you, without paying per connected player.',
    product:null, tag:'Unity', date:null, body:null },
  { slug:'mobile-reconnection', title:'Mobile reconnection without losing the player',
    excerpt:'The connection drops all the time on mobile. How to resume the session and return to the right state.',
    product:null, tag:'Unity', date:null, body:null },
  { slug:'server-authoritative-validation', title:'Server-authoritative validation in practice',
    excerpt:'Why the client can’t be the source of truth — and where to put validation so it survives cheating.',
    product:null, tag:'Unity', date:null, body:null },
  { slug:'offline-progress-timers', title:'Offline-progress timers that resist cheating',
    excerpt:'How to compute progress while the game is closed without changing the phone clock ruining everything.',
    product:null, tag:'Unity', date:null, body:null },
];

export function BlogPage() {
  return (
    <SiteShell active="" title="Blog" desc="Multiplayer, server and mobile — technical notes from the people who build the tools. One post a month.">
      <PageHead tag="Technical blog" title="Notes from" accent="the makers."
        lead="Multiplayer, server and mobile — what we learned building the tools. One post a month, no filler." />
      <section style={{ ...sec, paddingTop:0 }}>
        <div style={{ maxWidth:900, margin:'0 auto', display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(300px,1fr))', gap:18 }}>
          {POSTS.map((p,i) => {
            const soon = !p.body;
            return (
              <Link key={p.slug} to={`/blog/${p.slug}`} className="work reveal" style={{ textDecoration:'none',background:CARD,border:`1px solid ${LINE}`,borderRadius:18,padding:'26px 26px 24px',display:'flex',flexDirection:'column',transitionDelay:`${i*70}ms` }}>
                <div style={{ display:'flex',alignItems:'center',gap:8,marginBottom:14 }}>
                  <span style={{ fontSize:11,fontWeight:700,color:P,background:'rgba(163,102,255,.12)',padding:'4px 10px',borderRadius:999,letterSpacing:'.04em' }}>{p.tag}</span>
                  {soon && <span style={{ marginLeft:'auto',fontSize:11,fontWeight:600,color:'#E0A82E' }}>Coming soon</span>}
                </div>
                <h3 style={{ ...H1,fontSize:19,color:INK,marginBottom:10,lineHeight:1.25 }}>{p.title}</h3>
                <p style={{ fontSize:14.5,color:SUB,lineHeight:1.65,fontWeight:500,flex:1,marginBottom:16 }}>{p.excerpt}</p>
                <span style={{ fontSize:14,fontWeight:600,color:P }}>{soon?'Read when it’s out →':'Read article →'}</span>
              </Link>
            );
          })}
        </div>
      </section>
    </SiteShell>
  );
}

export function BlogPost() {
  const { slug } = useParams();
  const p = POSTS.find(x => x.slug === slug);
  if (!p) return <Navigate to="/blog" replace />;
  const rel = p.product;
  return (
    <SiteShell active="" title={p.title} desc={p.excerpt}>
      <header style={{ position:'relative',overflow:'hidden',padding:'clamp(112px,15vw,164px) clamp(20px,5vw,48px) clamp(28px,4vw,40px)' }}>
        <div className="glowA" style={{ position:'absolute',top:'-30%',left:'50%',transform:'translateX(-50%)',width:760,height:760,background:'radial-gradient(circle,rgba(163,102,255,.14) 0%,transparent 62%)',pointerEvents:'none' }} />
        <div style={{ position:'relative',zIndex:1,maxWidth:760,margin:'0 auto' }}>
          <Link to="/blog" className="fl" style={{ marginBottom:18,display:'inline-block' }}>← Blog</Link>
          <div className="hero-r" style={{ marginBottom:14 }}>
            <span style={{ fontSize:11,fontWeight:700,color:P,background:'rgba(163,102,255,.12)',padding:'5px 12px',borderRadius:999,letterSpacing:'.05em' }}>{p.tag}</span>
          </div>
          <h1 className="hero-r" style={{ ...H1,fontSize:'clamp(30px,4.6vw,48px)',lineHeight:1.08,color:INK,animationDelay:'.1s' }}>{p.title}</h1>
          <p className="hero-r" style={{ fontSize:18,color:SUB,lineHeight:1.6,fontWeight:500,marginTop:16,animationDelay:'.2s' }}>{p.excerpt}</p>
        </div>
      </header>

      <section style={{ padding:'0 clamp(20px,5vw,48px) clamp(48px,7vw,80px)' }}>
        <div style={{ maxWidth:720, margin:'0 auto' }}>
          {p.body ? (
            <article style={{ fontSize:17,color:'#D6D5DE',lineHeight:1.8,fontWeight:400 }}>
              {p.body.map((blk,i) =>
                blk.h
                  ? <h2 key={i} style={{ ...H1,fontSize:24,color:INK,margin:'34px 0 12px' }}>{blk.h}</h2>
                  : <p key={i} style={{ marginBottom:18 }}>{blk.p}</p>)}
            </article>
          ) : (
            <div className="reveal" style={{ background:CARD,border:`1px dashed ${LINE}`,borderRadius:18,padding:'40px 30px',textAlign:'center' }}>
              <div style={{ fontSize:34,marginBottom:14 }}>✍️</div>
              <h2 style={{ ...H1,fontSize:22,color:INK,marginBottom:10 }}>Article on the way.</h2>
              <p style={{ fontSize:15,color:SUB,fontWeight:500,maxWidth:420,margin:'0 auto',lineHeight:1.7 }}>This is one of the next topics on the blog. Until it's out, take a look at the tool it's about.</p>
            </div>
          )}

          {rel && (
            <div className="reveal" style={{ marginTop:36,background:BG2,border:`1px solid ${LINE}`,borderRadius:18,padding:'26px 28px',display:'flex',alignItems:'center',gap:18,flexWrap:'wrap' }}>
              <div style={{ flex:1,minWidth:220 }}>
                <p style={{ fontSize:12,letterSpacing:'.1em',textTransform:'uppercase',color:SUB,fontWeight:600,marginBottom:6 }}>Related tool</p>
                <p style={{ ...H1,fontSize:18,color:INK }}>See this article's product</p>
              </div>
              <Link to={`/produtos/${rel}`} className="btn-p">View product →</Link>
            </div>
          )}
        </div>
      </section>
    </SiteShell>
  );
}
